import React from 'react';
import type { ReactNode } from 'react';
import { TabItem } from './TabItem';
import type { TabItemProps } from './TabItem';

export const hasExactMatch = (children: ReactNode): boolean => {
  const exactMatch: string[] = [];
  React.Children.forEach(children, (child) => {
    if (React.isValidElement<TabItemProps>(child) && child.type === TabItem) {
      const { url } = child.props;
      if (window.location.pathname === url) exactMatch.push(url);
    }
  });
  return !!exactMatch.length;
};
